// AUTO-GENERATED by scripts/generate-lucide-icons.js — do not edit manually
// 214 icon module(s) detected from source scan (224 name(s) including Lucide aliases)
//
// To regenerate: node scripts/generate-lucide-icons.js
// To check if up-to-date: node scripts/generate-lucide-icons.js --check

import { createIcons } from './create-icons.js';

// Per-icon imports to avoid pulling in the full lucide barrel (1,600+ icons)
import { default as Activity } from 'lucide/dist/esm/icons/activity.js';
import { default as AlarmClock } from 'lucide/dist/esm/icons/alarm-clock.js';
import { default as AlertCircle } from 'lucide/dist/esm/icons/circle-alert.js';
import { default as AlertTriangle } from 'lucide/dist/esm/icons/triangle-alert.js';
import { default as Archive } from 'lucide/dist/esm/icons/archive.js';
import { default as ArchiveRestore } from 'lucide/dist/esm/icons/archive-restore.js';
import { default as ArrowDown } from 'lucide/dist/esm/icons/arrow-down.js';
import { default as ArrowLeft } from 'lucide/dist/esm/icons/arrow-left.js';
import { default as ArrowRight } from 'lucide/dist/esm/icons/arrow-right.js';
import { default as ArrowUp } from 'lucide/dist/esm/icons/arrow-up.js';
import { default as ArrowUpDown } from 'lucide/dist/esm/icons/arrow-up-down.js';
import { default as Asterisk } from 'lucide/dist/esm/icons/asterisk.js';
import { default as AtSign } from 'lucide/dist/esm/icons/at-sign.js';
import { default as BadgeCheck } from 'lucide/dist/esm/icons/badge-check.js';
import { default as Ban } from 'lucide/dist/esm/icons/ban.js';
import { default as Beer } from 'lucide/dist/esm/icons/beer.js';
import { default as Bell } from 'lucide/dist/esm/icons/bell.js';
import { default as BellOff } from 'lucide/dist/esm/icons/bell-off.js';
import { default as Book } from 'lucide/dist/esm/icons/book.js';
import { default as Bookmark } from 'lucide/dist/esm/icons/bookmark.js';
import { default as BookmarkMinus } from 'lucide/dist/esm/icons/bookmark-minus.js';
import { default as BookOpen } from 'lucide/dist/esm/icons/book-open.js';
import { default as Bot } from 'lucide/dist/esm/icons/bot.js';
import { default as Box } from 'lucide/dist/esm/icons/box.js';
import { default as Briefcase } from 'lucide/dist/esm/icons/briefcase.js';
import { default as Bug } from 'lucide/dist/esm/icons/bug.js';
import { default as Building } from 'lucide/dist/esm/icons/building.js';
import { default as Cake } from 'lucide/dist/esm/icons/cake.js';
import { default as Calendar } from 'lucide/dist/esm/icons/calendar.js';
import { default as CalendarDays } from 'lucide/dist/esm/icons/calendar-days.js';
import { default as CalendarPlus } from 'lucide/dist/esm/icons/calendar-plus.js';
import { default as Camera } from 'lucide/dist/esm/icons/camera.js';
import { default as Check } from 'lucide/dist/esm/icons/check.js';
import { default as CheckCheck } from 'lucide/dist/esm/icons/check-check.js';
import { default as CheckCircle } from 'lucide/dist/esm/icons/circle-check-big.js';
import { default as CheckCircle2 } from 'lucide/dist/esm/icons/circle-check.js';
import { default as CheckSquare } from 'lucide/dist/esm/icons/square-check-big.js';
import { default as ChevronDown } from 'lucide/dist/esm/icons/chevron-down.js';
import { default as ChevronLeft } from 'lucide/dist/esm/icons/chevron-left.js';
import { default as ChevronRight } from 'lucide/dist/esm/icons/chevron-right.js';
import { default as ChevronsDownUp } from 'lucide/dist/esm/icons/chevrons-down-up.js';
import { default as ChevronUp } from 'lucide/dist/esm/icons/chevron-up.js';
import { default as Circle } from 'lucide/dist/esm/icons/circle.js';
import { default as CircleDot } from 'lucide/dist/esm/icons/circle-dot.js';
import { default as CircleHelp } from 'lucide/dist/esm/icons/circle-question-mark.js';
import { default as CirclePlay } from 'lucide/dist/esm/icons/circle-play.js';
import { default as CircleSlash } from 'lucide/dist/esm/icons/circle-slash.js';
import { default as CircleStop } from 'lucide/dist/esm/icons/circle-stop.js';
import { default as ClipboardCheck } from 'lucide/dist/esm/icons/clipboard-check.js';
import { default as ClipboardList } from 'lucide/dist/esm/icons/clipboard-list.js';
import { default as Clock } from 'lucide/dist/esm/icons/clock.js';
import { default as ClockAlert } from 'lucide/dist/esm/icons/clock-alert.js';
import { default as Code } from 'lucide/dist/esm/icons/code.js';
import { default as Coffee } from 'lucide/dist/esm/icons/coffee.js';
import { default as Compass } from 'lucide/dist/esm/icons/compass.js';
import { default as Cookie } from 'lucide/dist/esm/icons/cookie.js';
import { default as Copy } from 'lucide/dist/esm/icons/copy.js';
import { default as CornerDownRight } from 'lucide/dist/esm/icons/corner-down-right.js';
import { default as Cpu } from 'lucide/dist/esm/icons/cpu.js';
import { default as CreditCard } from 'lucide/dist/esm/icons/credit-card.js';
import { default as Crop } from 'lucide/dist/esm/icons/crop.js';
import { default as Crosshair } from 'lucide/dist/esm/icons/crosshair.js';
import { default as Crown } from 'lucide/dist/esm/icons/crown.js';
import { default as Download } from 'lucide/dist/esm/icons/download.js';
import { default as Ellipsis } from 'lucide/dist/esm/icons/ellipsis.js';
import { default as EllipsisVertical } from 'lucide/dist/esm/icons/ellipsis-vertical.js';
import { default as Eraser } from 'lucide/dist/esm/icons/eraser.js';
import { default as ExternalLink } from 'lucide/dist/esm/icons/external-link.js';
import { default as Eye } from 'lucide/dist/esm/icons/eye.js';
import { default as EyeOff } from 'lucide/dist/esm/icons/eye-off.js';
import { default as FileText } from 'lucide/dist/esm/icons/file-text.js';
import { default as FileX } from 'lucide/dist/esm/icons/file-x.js';
import { default as Film } from 'lucide/dist/esm/icons/film.js';
import { default as Filter } from 'lucide/dist/esm/icons/funnel.js';
import { default as Fingerprint } from 'lucide/dist/esm/icons/fingerprint.js';
import { default as Flag } from 'lucide/dist/esm/icons/flag.js';
import { default as Flame } from 'lucide/dist/esm/icons/flame.js';
import { default as Folder } from 'lucide/dist/esm/icons/folder.js';
import { default as FolderInput } from 'lucide/dist/esm/icons/folder-input.js';
import { default as FolderOpen } from 'lucide/dist/esm/icons/folder-open.js';
import { default as Gamepad2 } from 'lucide/dist/esm/icons/gamepad-2.js';
import { default as Gavel } from 'lucide/dist/esm/icons/gavel.js';
import { default as GitBranch } from 'lucide/dist/esm/icons/git-branch.js';
import { default as GitMerge } from 'lucide/dist/esm/icons/git-merge.js';
import { default as Globe } from 'lucide/dist/esm/icons/globe.js';
import { default as GraduationCap } from 'lucide/dist/esm/icons/graduation-cap.js';
import { default as Grid2x2 } from 'lucide/dist/esm/icons/grid-2x2.js';
import { default as HandHeart } from 'lucide/dist/esm/icons/hand-heart.js';
import { default as Handshake } from 'lucide/dist/esm/icons/handshake.js';
import { default as Headphones } from 'lucide/dist/esm/icons/headphones.js';
import { default as Heart } from 'lucide/dist/esm/icons/heart.js';
import { default as HeartHandshake } from 'lucide/dist/esm/icons/heart-handshake.js';
import { default as HeartPulse } from 'lucide/dist/esm/icons/heart-pulse.js';
import { default as History } from 'lucide/dist/esm/icons/history.js';
import { default as Home } from 'lucide/dist/esm/icons/house.js';
import { default as Hourglass } from 'lucide/dist/esm/icons/hourglass.js';
import { default as Image } from 'lucide/dist/esm/icons/image.js';
import { default as ImageOff } from 'lucide/dist/esm/icons/image-off.js';
import { default as ImagePlus } from 'lucide/dist/esm/icons/image-plus.js';
import { default as Images } from 'lucide/dist/esm/icons/images.js';
import { default as Inbox } from 'lucide/dist/esm/icons/inbox.js';
import { default as Info } from 'lucide/dist/esm/icons/info.js';
import { default as Key } from 'lucide/dist/esm/icons/key.js';
import { default as KeyRound } from 'lucide/dist/esm/icons/key-round.js';
import { default as Languages } from 'lucide/dist/esm/icons/languages.js';
import { default as Laptop } from 'lucide/dist/esm/icons/laptop.js';
import { default as Layers } from 'lucide/dist/esm/icons/layers.js';
import { default as Lightbulb } from 'lucide/dist/esm/icons/lightbulb.js';
import { default as List } from 'lucide/dist/esm/icons/list.js';
import { default as ListChecks } from 'lucide/dist/esm/icons/list-checks.js';
import { default as Loader2 } from 'lucide/dist/esm/icons/loader-circle.js';
import { default as Lock } from 'lucide/dist/esm/icons/lock.js';
import { default as LogIn } from 'lucide/dist/esm/icons/log-in.js';
import { default as LogOut } from 'lucide/dist/esm/icons/log-out.js';
import { default as Mail } from 'lucide/dist/esm/icons/mail.js';
import { default as MailCheck } from 'lucide/dist/esm/icons/mail-check.js';
import { default as MailWarning } from 'lucide/dist/esm/icons/mail-warning.js';
import { default as MailX } from 'lucide/dist/esm/icons/mail-x.js';
import { default as MapPin } from 'lucide/dist/esm/icons/map-pin.js';
import { default as Megaphone } from 'lucide/dist/esm/icons/megaphone.js';
import { default as MessageCircle } from 'lucide/dist/esm/icons/message-circle.js';
import { default as MessageCircleHeart } from 'lucide/dist/esm/icons/message-circle-heart.js';
import { default as MessageCircleOff } from 'lucide/dist/esm/icons/message-circle-off.js';
import { default as MessageSquare } from 'lucide/dist/esm/icons/message-square.js';
import { default as MessageSquarePlus } from 'lucide/dist/esm/icons/message-square-plus.js';
import { default as MessageSquareWarning } from 'lucide/dist/esm/icons/message-square-warning.js';
import { default as MessagesSquare } from 'lucide/dist/esm/icons/messages-square.js';
import { default as Mic } from 'lucide/dist/esm/icons/mic.js';
import { default as MicOff } from 'lucide/dist/esm/icons/mic-off.js';
import { default as MinusCircle } from 'lucide/dist/esm/icons/circle-minus.js';
import { default as Monitor } from 'lucide/dist/esm/icons/monitor.js';
import { default as Moon } from 'lucide/dist/esm/icons/moon.js';
import { default as MoveHorizontal } from 'lucide/dist/esm/icons/move-horizontal.js';
import { default as Music } from 'lucide/dist/esm/icons/music.js';
import { default as Navigation } from 'lucide/dist/esm/icons/navigation.js';
import { default as Newspaper } from 'lucide/dist/esm/icons/newspaper.js';
import { default as Palette } from 'lucide/dist/esm/icons/palette.js';
import { default as PanelRightOpen } from 'lucide/dist/esm/icons/panel-right-open.js';
import { default as Paperclip } from 'lucide/dist/esm/icons/paperclip.js';
import { default as PartyPopper } from 'lucide/dist/esm/icons/party-popper.js';
import { default as Pause } from 'lucide/dist/esm/icons/pause.js';
import { default as PauseCircle } from 'lucide/dist/esm/icons/circle-pause.js';
import { default as PawPrint } from 'lucide/dist/esm/icons/paw-print.js';
import { default as Pencil } from 'lucide/dist/esm/icons/pencil.js';
import { default as PencilLine } from 'lucide/dist/esm/icons/pencil-line.js';
import { default as Phone } from 'lucide/dist/esm/icons/phone.js';
import { default as PhoneOff } from 'lucide/dist/esm/icons/phone-off.js';
import { default as PhoneOutgoing } from 'lucide/dist/esm/icons/phone-outgoing.js';
import { default as Pill } from 'lucide/dist/esm/icons/pill.js';
import { default as Plane } from 'lucide/dist/esm/icons/plane.js';
import { default as Play } from 'lucide/dist/esm/icons/play.js';
import { default as Plus } from 'lucide/dist/esm/icons/plus.js';
import { default as PlusCircle } from 'lucide/dist/esm/icons/circle-plus.js';
import { default as Quote } from 'lucide/dist/esm/icons/quote.js';
import { default as Radio } from 'lucide/dist/esm/icons/radio.js';
import { default as RefreshCw } from 'lucide/dist/esm/icons/refresh-cw.js';
import { default as Repeat } from 'lucide/dist/esm/icons/repeat.js';
import { default as Reply } from 'lucide/dist/esm/icons/reply.js';
import { default as RotateCcw } from 'lucide/dist/esm/icons/rotate-ccw.js';
import { default as RotateCw } from 'lucide/dist/esm/icons/rotate-cw.js';
import { default as Scale } from 'lucide/dist/esm/icons/scale.js';
import { default as ScanSearch } from 'lucide/dist/esm/icons/scan-search.js';
import { default as ScrollText } from 'lucide/dist/esm/icons/scroll-text.js';
import { default as Search } from 'lucide/dist/esm/icons/search.js';
import { default as SearchX } from 'lucide/dist/esm/icons/search-x.js';
import { default as Send } from 'lucide/dist/esm/icons/send.js';
import { default as Settings } from 'lucide/dist/esm/icons/settings.js';
import { default as Settings2 } from 'lucide/dist/esm/icons/settings-2.js';
import { default as Share } from 'lucide/dist/esm/icons/share.js';
import { default as Shield } from 'lucide/dist/esm/icons/shield.js';
import { default as ShieldAlert } from 'lucide/dist/esm/icons/shield-alert.js';
import { default as ShieldCheck } from 'lucide/dist/esm/icons/shield-check.js';
import { default as ShieldOff } from 'lucide/dist/esm/icons/shield-off.js';
import { default as SlidersHorizontal } from 'lucide/dist/esm/icons/sliders-horizontal.js';
import { default as Smartphone } from 'lucide/dist/esm/icons/smartphone.js';
import { default as Smile } from 'lucide/dist/esm/icons/smile.js';
import { default as SmilePlus } from 'lucide/dist/esm/icons/smile-plus.js';
import { default as Sparkles } from 'lucide/dist/esm/icons/sparkles.js';
import { default as SquarePen } from 'lucide/dist/esm/icons/square-pen.js';
import { default as Star } from 'lucide/dist/esm/icons/star.js';
import { default as StickyNote } from 'lucide/dist/esm/icons/sticky-note.js';
import { default as Sun } from 'lucide/dist/esm/icons/sun.js';
import { default as SwitchCamera } from 'lucide/dist/esm/icons/switch-camera.js';
import { default as Tablet } from 'lucide/dist/esm/icons/tablet.js';
import { default as Tag } from 'lucide/dist/esm/icons/tag.js';
import { default as Tags } from 'lucide/dist/esm/icons/tags.js';
import { default as Target } from 'lucide/dist/esm/icons/target.js';
import { default as TextSearch } from 'lucide/dist/esm/icons/text-search.js';
import { default as Trash2 } from 'lucide/dist/esm/icons/trash-2.js';
import { default as Trophy } from 'lucide/dist/esm/icons/trophy.js';
import { default as Truck } from 'lucide/dist/esm/icons/truck.js';
import { default as Tv } from 'lucide/dist/esm/icons/tv.js';
import { default as Type } from 'lucide/dist/esm/icons/type.js';
import { default as Undo2 } from 'lucide/dist/esm/icons/undo-2.js';
import { default as Unlock } from 'lucide/dist/esm/icons/lock-open.js';
import { default as User } from 'lucide/dist/esm/icons/user.js';
import { default as UserCheck } from 'lucide/dist/esm/icons/user-check.js';
import { default as UserCircle } from 'lucide/dist/esm/icons/circle-user.js';
import { default as UserCog } from 'lucide/dist/esm/icons/user-cog.js';
import { default as UserMinus } from 'lucide/dist/esm/icons/user-minus.js';
import { default as UserPlus } from 'lucide/dist/esm/icons/user-plus.js';
import { default as UserRound } from 'lucide/dist/esm/icons/user-round.js';
import { default as UserRoundCog } from 'lucide/dist/esm/icons/user-round-cog.js';
import { default as UserRoundPlus } from 'lucide/dist/esm/icons/user-round-plus.js';
import { default as Users } from 'lucide/dist/esm/icons/users.js';
import { default as Users2 } from 'lucide/dist/esm/icons/users-round.js';
import { default as UserX } from 'lucide/dist/esm/icons/user-x.js';
import { default as Utensils } from 'lucide/dist/esm/icons/utensils.js';
import { default as VenetianMask } from 'lucide/dist/esm/icons/venetian-mask.js';
import { default as Video } from 'lucide/dist/esm/icons/video.js';
import { default as VideoOff } from 'lucide/dist/esm/icons/video-off.js';
import { default as X } from 'lucide/dist/esm/icons/x.js';
import { default as XCircle } from 'lucide/dist/esm/icons/circle-x.js';
import { default as Zap } from 'lucide/dist/esm/icons/zap.js';

export const icons = {
    Activity,
    AlarmClock,
    AlertCircle,
    CircleAlert: AlertCircle,
    AlertTriangle,
    TriangleAlert: AlertTriangle,
    Archive,
    ArchiveRestore,
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    ArrowUpDown,
    Asterisk,
    AtSign,
    BadgeCheck,
    Ban,
    Beer,
    Bell,
    BellOff,
    Book,
    Bookmark,
    BookmarkMinus,
    BookOpen,
    Bot,
    Box,
    Briefcase,
    Bug,
    Building,
    Cake,
    Calendar,
    CalendarDays,
    CalendarPlus,
    Camera,
    Check,
    CheckCheck,
    CheckCircle,
    CircleCheckBig: CheckCircle,
    CheckCircle2,
    CircleCheck: CheckCircle2,
    CheckSquare,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronsDownUp,
    ChevronUp,
    Circle,
    CircleDot,
    CircleHelp,
    HelpCircle: CircleHelp,
    CirclePlay,
    PlayCircle: CirclePlay,
    CircleSlash,
    CircleStop,
    ClipboardCheck,
    ClipboardList,
    Clock,
    ClockAlert,
    Code,
    Coffee,
    Compass,
    Cookie,
    Copy,
    CornerDownRight,
    Cpu,
    CreditCard,
    Crop,
    Crosshair,
    Crown,
    Download,
    Ellipsis,
    MoreHorizontal: Ellipsis,
    EllipsisVertical,
    Eraser,
    ExternalLink,
    Eye,
    EyeOff,
    FileText,
    FileX,
    Film,
    Filter,
    Fingerprint,
    Flag,
    Flame,
    Folder,
    FolderInput,
    FolderOpen,
    Gamepad2,
    Gavel,
    GitBranch,
    GitMerge,
    Globe,
    GraduationCap,
    Grid2x2,
    HandHeart,
    Handshake,
    Headphones,
    Heart,
    HeartHandshake,
    HeartPulse,
    History,
    Home,
    House: Home,
    Hourglass,
    Image,
    ImageOff,
    ImagePlus,
    Images,
    Inbox,
    Info,
    Key,
    KeyRound,
    Languages,
    Laptop,
    Layers,
    Lightbulb,
    List,
    ListChecks,
    Loader2,
    LoaderCircle: Loader2,
    Lock,
    LogIn,
    LogOut,
    Mail,
    MailCheck,
    MailWarning,
    MailX,
    MapPin,
    Megaphone,
    MessageCircle,
    MessageCircleHeart,
    MessageCircleOff,
    MessageSquare,
    MessageSquarePlus,
    MessageSquareWarning,
    MessagesSquare,
    Mic,
    MicOff,
    MinusCircle,
    Monitor,
    Moon,
    MoveHorizontal,
    Music,
    Navigation,
    Newspaper,
    Palette,
    PanelRightOpen,
    Paperclip,
    PartyPopper,
    Pause,
    PauseCircle,
    PawPrint,
    Pencil,
    PencilLine,
    Phone,
    PhoneOff,
    PhoneOutgoing,
    Pill,
    Plane,
    Play,
    Plus,
    PlusCircle,
    Quote,
    Radio,
    RefreshCw,
    Repeat,
    Reply,
    RotateCcw,
    RotateCw,
    Scale,
    ScanSearch,
    ScrollText,
    Search,
    SearchX,
    Send,
    Settings,
    Settings2,
    Share,
    Shield,
    ShieldAlert,
    ShieldCheck,
    ShieldOff,
    SlidersHorizontal,
    Smartphone,
    Smile,
    SmilePlus,
    Sparkles,
    SquarePen,
    Star,
    StickyNote,
    Sun,
    SwitchCamera,
    Tablet,
    Tag,
    Tags,
    Target,
    TextSearch,
    Trash2,
    Trophy,
    Truck,
    Tv,
    Type,
    Undo2,
    Unlock,
    User,
    UserCheck,
    UserCircle,
    UserCog,
    UserMinus,
    UserPlus,
    UserRound,
    UserRoundCog,
    UserRoundPlus,
    Users,
    Users2,
    UsersRound: Users2,
    UserX,
    Utensils,
    VenetianMask,
    Video,
    VideoOff,
    X,
    XCircle,
    Zap
};

export { createIcons };
